import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from 'react'

import type { FilterOptionValue } from '@/modules/expiring-fans/components/tables/fans/expiring-fans-table.tsx'

interface ExpiringFansFilterContextType {
  filter: FilterOptionValue | string
  setFilter: React.Dispatch<React.SetStateAction<FilterOptionValue | string>>
}

const ExpiringFansFilterContext = createContext<
  ExpiringFansFilterContextType | undefined
>(undefined)

export const ExpiringFansFilterProvider = ({ children }: PropsWithChildren) => {
  const [filter, setFilter] = useState<FilterOptionValue | string>('all')

  const value = { filter, setFilter }

  return (
    <ExpiringFansFilterContext.Provider value={value}>
      {children}
    </ExpiringFansFilterContext.Provider>
  )
}

export function useExpiringFansFilter() {
  const context = useContext(ExpiringFansFilterContext)

  if (context === undefined) {
    throw new Error(
      'useExpiringFansFilter must be used within a ExpiringFansFilterProvider',
    )
  }

  return context
}
